import api from './apiClient';
import { ApiResponse } from 'shared/types/api';
import { PendingCounts } from './authService';

export interface PendingPerCompany {
  companyId: string;
  companyName: string;
  /** Resolved presigned URL for the company logo (null when no logo set). */
  logoUrl?: string | null;
  pending: PendingCounts;
}

/**
 * Wrapper for `GET /api/users/me/pending-across-companies`. Returns the
 * authenticated user's pending counts (verifications, evaluations,
 * permits, fichas) for every active company they belong to. Used by:
 *   - CompanySelector (inlined by /auth/login response, not a separate call)
 *   - ProfileDrawer "Cambiar de empresa" section
 */
export const userPendingApi = {
  getAcrossCompanies: async (): Promise<PendingPerCompany[]> => {
    const res = await api.get<ApiResponse<PendingPerCompany[]>>(
      '/users/me/pending-across-companies',
    );
    return (res as ApiResponse<PendingPerCompany[]>).data || [];
  },
};

export default userPendingApi;
